import { useQuery } from '@tanstack/react-query';
import { organizationRoleApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useRoleDetail(id: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.organization.roleDetail(id ?? -1),
    queryFn: ({ signal }) =>
      organizationRoleApiClient.get(id!, toCancelToken(signal)),
    enabled: id != null && !Number.isNaN(id),
    staleTime: 0,
    meta: { errorContext: 'role detail' },
  });
}
